import { FC, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { Switcher } from 'components/Switcher';
import { EndUseSamlData } from './types';
import axios from 'server';
import { useAppPreloader } from 'hooks/useAppPreloader';
const EndUserSamlTable: FC = () => {
  const fetchEndUserSaml = async (): Promise<EndUseSamlData[]> => {
    const response = await axios.get('user/saml-connected-apps');
    const raw = response.data;

    if (Array.isArray(raw)) {
      return raw;
    }

    if (Array.isArray(raw?.data)) {
      return raw.data;
    }

    if (raw?.data && typeof raw.data === 'object' && raw.data.idp_name) {
      return [raw.data];
    }

    if (Array.isArray(raw?.items)) {
      return raw.items;
    }

    if (raw && typeof raw === 'object' && raw.idp_name) {
      return [raw];
    }

    return [];
  };

  const {
    data: EndUserSamlList = [],
    isLoading: isFetchingEndUserSaml,
    isFetching,
    isError: isEndUserSamlError,
  } = useQuery<EndUseSamlData[]>('saml/idp-details', fetchEndUserSaml, {
    refetchOnWindowFocus: false,
    refetchOnMount: 'always',
    staleTime: 0,
  });

  const handleView = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    document.title = 'EasyIdentity: Settings: End Users';
  }, []);

  useAppPreloader(isFetchingEndUserSaml || isFetching);
  return (
    <>
      {isFetchingEndUserSaml ? (
        <></>
      ) : isEndUserSamlError ? (
        <Typography color='error' style={{ padding: 20 }}>
          Failed to load SAML Service Providers.
        </Typography>
      ) : EndUserSamlList.length === 0 ? (
        <Typography
          style={{
            padding: 20,
            textAlign: 'center',
          }}
        >
          No SAML Service Providers found.
        </Typography>
      ) : (
        // <Grid container spacing={3} style={{ padding: '8px 0' }}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>App Name </strong>
                </TableCell>
                <TableCell>
                  <strong>Provider </strong>
                </TableCell>
                <TableCell>
                  <strong>Login Url</strong>
                </TableCell>
                <TableCell align='right'>
                  <strong>Status</strong>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {EndUserSamlList.map((combine) => (
                <TableRow key={combine.id} hover>
                  {/* Provider */}
                  <TableCell>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                        minWidth: 0,
                      }}
                    >
                      {/* Provider Name */}
                      <Typography
                        style={{
                          fontWeight: 700,
                          fontSize: 15,
                          color: '#111827',
                          wordBreak: 'break-word',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleView(combine.login_url)}
                      >
                        {combine.app_name || '-'}
                      </Typography>
                    </div>
                  </TableCell>
                  <TableCell>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                        minWidth: 0,
                      }}
                    >
                      {/* Provider Name */}
                      <Typography
                        style={{
                          // fontWeight: 700,
                          fontSize: 15,
                          color: '#6b7280',
                          wordBreak: 'break-word',
                        }}
                      >
                        {combine.provider || '-'}
                      </Typography>
                    </div>
                  </TableCell>
                  {/* Entity ID */}
                  <TableCell>
                    <Typography
                      style={{
                        color: '#6b7280',
                        fontSize: 13,
                        wordBreak: 'break-word',
                        overflowWrap: 'anywhere',
                      }}
                    >
                      {combine.login_url || '-'}
                    </Typography>
                  </TableCell>

                  <TableCell align='right'>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        gap: 4,
                      }}
                    >
                      <Switcher checked={combine.is_connected === true} />
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default EndUserSamlTable;
